import React from "react";
import PropTypes from "prop-types";
import {
  triggerNavigation,
  ingestData,
} from "../../bridges/BridgeServices";
import "./ctaLabel.scss";
import { CTA_TYPES_EVENT_MAP } from "../../utils/constants";

const CTALabel = props => {
  const {
    ctaTitle = "",
    ctaSubtitle = "",
    ctaAppDeeplink = "",
    ctaWebLink = "",
    faqTitle = "",
    ctaType = "",
    className = "",
  } = props;

  const handleClick = () => {
    triggerNavigation({
      deepLink: ctaAppDeeplink,
      webURL: ctaWebLink,
    });
    ingestData({
      name: CTA_TYPES_EVENT_MAP[ctaType],
      data: {
        faqTitle,
      },
    });
  };

  return (
    <div className={`cta-wrapper ${className}`}>
      <p className="cta-desc">{ctaSubtitle}</p>
      <button className="cta" onClick={handleClick}>
        {ctaTitle}
      </button>
    </div>
  );
};

CTALabel.propTypes = {
  ctaTitle: PropTypes.string,
  ctaSubtitle: PropTypes.string,
  ctaAppDeeplink: PropTypes.string,
  ctaWebLink: PropTypes.string,
  ctaType: PropTypes.string,
  faqTitle: PropTypes.string,
  className: PropTypes.string,
};

export default CTALabel;
